import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'organization' }) => {
  // Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Officine del Cuore",
    "description": "Agenzia matrimoniale professionale dal 2006, specializzata in incontri seri e relazioni durature. Operiamo a Napoli, Caserta e Roma.",
    "url": "https://www.officinedelcuore.it",
    "logo": "https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/upmb4kcx_NUOVO%20LOGO%20OFFICINE2.webp",
    "foundingDate": "2006",
    "email": "info@officinedelcuore.it",
    "telephone": "+393292626152",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Via G. Testa, 16",
      "addressLocality": "Napoli",
      "addressRegion": "NA",
      "addressCountry": "IT"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Napoli"
      },
      {
        "@type": "City",
        "name": "Caserta"
      },
      {
        "@type": "City",
        "name": "Roma"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/officinedelcuore"
    ]
  };

  // LocalBusiness Schema for multiple locations
  const localBusinessSchema = [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Officine del Cuore - Napoli",
      "image": "https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/upmb4kcx_NUOVO%20LOGO%20OFFICINE2.webp",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Via G. Testa, 16",
        "addressLocality": "Napoli",
        "addressRegion": "NA",
        "addressCountry": "IT"
      },
      "telephone": "+393292626152",
      "email": "info@officinedelcuore.it",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "10:00",
          "closes": "19:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "18:00"
        }
      ],
      "priceRange": "€€€"
    },
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Officine del Cuore - Caserta",
      "image": "https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/upmb4kcx_NUOVO%20LOGO%20OFFICINE2.webp",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Viale Vincenzo Cappiello, 8",
        "addressLocality": "Caserta",
        "addressRegion": "CE",
        "addressCountry": "IT"
      },
      "telephone": "+393520567001",
      "email": "info@officinedelcuore.it",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "10:00",
          "closes": "19:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "18:00"
        }
      ],
      "priceRange": "€€€"
    },
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Officine del Cuore - Roma",
      "image": "https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/upmb4kcx_NUOVO%20LOGO%20OFFICINE2.webp",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "TERZO SPAZIO - Centro polifunzionale, Viale degli Ammiragli 67",
        "addressLocality": "Roma",
        "addressRegion": "RM",
        "addressCountry": "IT"
      },
      "telephone": "+393939327109",
      "email": "info@officinedelcuore.it",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "10:00",
          "closes": "19:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "10:00",
          "closes": "18:00"
        }
      ],
      "priceRange": "€€€"
    }
  ];

  // Service Schema
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Agenzia Matrimoniale",
    "provider": {
      "@type": "Organization",
      "name": "Officine del Cuore"
    },
    "description": "Servizio professionale di matchmaking per single alla ricerca di relazioni serie e durature",
    "areaServed": ["Napoli", "Caserta", "Roma"],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Servizi Matchmaking",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Colloquio Conoscitivo Gratuito"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Analisi di Compatibilità Personalizzata"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Presentazioni Mirate"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Assistenza Continua"
          }
        }
      ]
    }
  };

  const getSchema = () => {
    switch (type) {
      case 'organization':
        return organizationSchema;
      case 'localbusiness':
        return localBusinessSchema;
      case 'service':
        return serviceSchema;
      case 'all':
        return [organizationSchema, ...localBusinessSchema, serviceSchema];
      default:
        return organizationSchema;
    }
  };

  const schema = getSchema();

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
